import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38c3c1f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Buy Dune Tokens (TBA) ")
const _hoisted_2 = {
  href: "https://claim.houndrace.com/",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Open Mystery Box ")
const _hoisted_4 = {
  href: "https://discord.gg/N8AnA662Mx",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Join Alpha Dune Discord ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h2 = _resolveComponent("n-h2")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!

  return (_openBlock(), _createBlock(_component_n_grid, {
    "x-gap": "24",
    "y-gap": "24",
    cols: "12",
    "item-responsive": "",
    responsive: "screen"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_gi, { span: "12 m:6" }, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, {
            class: "link-card cover-1",
            hoverable: "",
            style: {"cursor":"unset"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_space, {
                vertical: "",
                style: {"height":"100%"},
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_space, { justify: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_h2, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, {
                            class: "link-card__title",
                            type: "default"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_n_gi, { span: "12 m:6" }, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_2, [
            _createVNode(_component_n_card, {
              class: "link-card cover-2",
              hoverable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_space, {
                  vertical: "",
                  style: {"height":"100%"},
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_h2, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, {
                              class: "link-card__title",
                              type: "default"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_n_gi, { span: "12 m:6" }, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_component_n_card, {
              class: "link-card cover-3",
              hoverable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_space, {
                  vertical: "",
                  style: {"height":"100%"},
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_h2, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, {
                              class: "link-card__title",
                              type: "default"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}